export const MIN_USER_AGE = 18

export function getMaxBirthdayDate(referenceDate = new Date()) {
  const maxDate = new Date(referenceDate)
  maxDate.setFullYear(maxDate.getFullYear() - MIN_USER_AGE)
  return maxDate
}

export function isAtLeastMinAge(birthday, minAge = MIN_USER_AGE) {
  if (!birthday) return false

  const birthDate = new Date(birthday)
  if (Number.isNaN(birthDate.getTime())) return false

  const today = new Date()
  let age = today.getFullYear() - birthDate.getFullYear()
  const monthDiff = today.getMonth() - birthDate.getMonth()

  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age -= 1
  }

  return age >= minAge
}
